import { render, staticRenderFns } from "./recuperaSenhaForm.vue?vue&type=template&id=6cb49939&scoped=true"
import script from "./recuperaSenhaForm.vue?vue&type=script&lang=js"
export * from "./recuperaSenhaForm.vue?vue&type=script&lang=js"
import style0 from "./recuperaSenhaForm.vue?vue&type=style&index=0&id=6cb49939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb49939",
  null
  
)

export default component.exports